
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/[...slug]",
      function () {
        return require("private-next-pages/clases/[...slug].js");
      }
    ]);
  